import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ device }) => (device === 'desktop' ? '32' : '16')}px;
`;

const ScoreContainer = styled.div`
  justify-content: center;
  align-items: center;
  gap: 16px;
  display: ${({ device }) => (device === 'desktop' ? 'inline-flex' : 'colum')};
  align-items: center;
`;

const LevelText = styled.div`
  display: flex;
  flex-direction: column;
  ${({ color }) => color};
  font-size: 32px;
  align-items: center;
  font-weight: 700;
`;

const InfoScore = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
  font-weight: 700;
  background: #ffebee;
  background: ${({ levelComparison }) => (levelComparison === 1 ? '#EBF4EB' : '#ffebee')};
  color: #000000;
  border-radius: 8px;
  padding: 4px 8px 4px 8px;
`;

const ContainerNivel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ device }) => (device === 'desktop' ? '32' : '16')}px;
  align-items: center;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ device }) => (device === 'desktop' ? '32' : '16')}px;
  align-items: center;
`;

const CenteredText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #484848;
  white-space: pre-line;
`;

const HelpText = styled.div`
  font-style: normal;
  font-weight: 600;
  text-align: center;
  font-size: ${({ device }) => (device === 'desktop' ? ' 20px' : '16px')};
`;

const Title = styled.p`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  padding-bottom: 4px;
`;

const SubtTitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding-bottom: 4px;
`;

const LinkSpn = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;

const Icon = styled.div`
  width: 16px;
  height: 16px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 8px;
  @media screen and (max-width: 360px) {
    margin-right: 4px;
  }
`;

export {
  Container,
  ContainerNivel,
  ImgContainer,
  CenteredText,
  HelpText,
  ScoreContainer,
  LevelText,
  InfoScore,
  Icon,
  LinkSpn,
  Title,
  SubtTitle
};
